import React from 'react';
import allianceLogo from '../../Asset/Alliance_maladies_rares.svg';
import Troisvies from '../../Asset/troisvies.jpg';
import EAlogo from '../../Asset/Logo-EA.jpg';
import Trouvea from '../../Asset/trouvea.jpg';
import FranceMutuelle from '../../Asset/france-mutuelle.jpg';
import BienEtre from '../../Asset/bien-etre.jpg';
import AVClogo from '../../Asset/AVC.png';
import DYSlogo from '../../Asset/dys.jpeg';
import unafam from '../../Asset/unafam.svg';
import Apf from '../../Asset/apf.svg';
import sosAmitie from '../../Asset/sos_amitier.png';
import secoursPopulaire from '../../Asset/secour-populaire.svg';
import hadParis from '../../Asset/had.png';
import cap from '../../Asset/cap.png';
import evolia from '../../Asset/evolia.webp';
import { Helmet } from 'react-helmet';
import { useColorMode, Box } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaExternalLinkAlt, FaHandshake } from 'react-icons/fa';

const NosPartenaires = () => {
    const { colorMode } = useColorMode();
    const isDark = colorMode === 'dark';

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.1 }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    const partenaires = [
        {
            nom: 'Alliance Maladies Rares',
            description: 'Alliance Maladies Rares regroupe des associations de patients pour améliorer la prise en charge des maladies rares.',
            site: 'https://www.alliance-maladies-rares.org',
            logo: allianceLogo,
        },
        {
            nom: 'Cap 92',
            description: 'Cap 92 propose un accompagnement aux personnes en situation de handicap dans le département des Hauts-de-Seine.',
            site: 'https://cap-92.fr/',
            logo: cap,
        },
        {
            nom: 'Évolia 93',
            description: 'Évolia 93 est une association qui accompagne les personnes âgées et en perte d\'autonomie en Seine-Saint-Denis.',
            site: 'https://www.evolia93.fr/',
            logo: evolia,
        },
        {
            nom: 'Fédération Française des DYS',
            description: 'Cette fédération accompagne les familles d\'enfants ayant des troubles spécifiques du langage et des apprentissages.',
            site: 'https://www.federationfrancaisedys.org',
            logo: DYSlogo,
        },
        {
            nom: 'France AVC',
            description: 'France AVC soutient les victimes d\'accidents vasculaires cérébraux et leurs familles dans leur réhabilitation.',
            site: 'https://www.franceavc.org',
            logo: AVClogo,
        },
        {
            nom: 'Association des Paralysés de France (APF)',
            description: 'L’APF milite pour les droits des personnes en situation de handicap et propose des services d\'accompagnement.',
            site: 'https://www.apf-francehandicap.org',
            logo: Apf,
        },
        {
            nom: 'UNAFAM',
            description: 'Union Nationale de Familles et Amis de Malades Mentaux, UNAFAM accompagne les familles d\'adultes atteints de troubles psychiques.',
            site: 'https://www.unafam.org',
            logo: unafam,
        },
        {
            nom: 'SOS Amitié',
            description: 'SOS Amitié propose un service d\'écoute pour toute personne en détresse, en offrant une écoute sans jugement.',
            site: 'https://www.sos-amitie.com',
            logo: sosAmitie,
        },
        {
            nom: 'Secours Populaire Français',
            description: 'Le Secours Populaire agit pour lutter contre la pauvreté et l\'exclusion sociale, en soutenant les personnes en difficulté.',
            site: 'https://www.secourspopulaire.fr',
            logo: secoursPopulaire,
        },
        {
            nom: 'HAD de Paris',
            description: 'Les hôpitaux de Paris collaborent avec PROSENIORS pour les prises en charge non médicales à domicile.',
            site: 'https://www.had-paris.fr',
            logo: hadParis,
        },
        {
            nom: 'France Mutuelle',
            description: 'Accompagne les personnes âgées et transporte les personnes à mobilité réduite.',
            site: 'https://www.francemutuelle.fr',
            logo: FranceMutuelle,
        },
        {
            nom: 'Trouvea.fr',
            description: 'Met en relation les particuliers avec des prestataires de services à la personne sur toute la France.',
            site: 'https://www.trouvea.fr',
            logo: Trouvea,
        },
        {
            nom: '3ème Vie',
            description: 'Propose des solutions d’hébergement en maison de retraite et de maintien à domicile.',
            site: 'https://www.3eme-vie.fr',
            logo: Troisvies,
        },
        {
            nom: 'Bien-être à la carte',
            description: 'Filiale du groupe Accor, elle confie des demandes d’accompagnement aux personnes âgées.',
            site: 'https://www.bienetrealacarte.fr',
            logo: BienEtre,
        },
        {
            nom: 'Europ Assistance',
            description: 'Propose des services de téléassistance pour les personnes âgées.',
            site: 'https://www.europ-assistance.fr',
            logo: EAlogo,
        },
    ];

    return (
        <Box className={isDark ? 'bg-[#0a0f16] min-h-screen' : 'bg-[#FAFCFF] min-h-screen'}>
            <Helmet>
                <title>Nos Partenaires — Hetep Iaout Services</title>
                <meta name="description" content="Hetep Iaout Services s'appuie sur un réseau de partenaires de confiance : associations, mutuelles et collectivités locales pour une prise en charge globale." />
                <link rel="canonical" href="https://www.hisvie.com/NosPartenaires/" />
            </Helmet>

            <div className="w-full">
                
                {/* --- HERO SECTION --- */}
                <header className="pt-40 pb-20 px-6 max-w-7xl mx-auto text-center">
                    <motion.div 
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <div className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full border mb-8 text-[10px] font-bold uppercase tracking-widest ${isDark ? 'bg-blue-900/30 border-blue-800 text-blue-300' : 'bg-blue-50 border-blue-100 text-blue-800'}`}>
                            <FaHandshake /> Réseau de confiance
                        </div>
                        <h1 className={`text-5xl md:text-8xl font-black mb-8 tracking-tighter leading-tight ${isDark ? 'text-white' : 'text-[#1B365D]'}`}>
                            Nos <span className="text-blue-600 font-serif italic font-light">Partenaires.</span>
                        </h1>
                        <p className={`text-xl md:text-2xl max-w-3xl mx-auto font-light leading-relaxed ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                            Découvrez les associations et structures qui travaillent à nos côtés pour vous offrir un accompagnement d'excellence.
                        </p>
                        <div className="w-24 h-1 bg-blue-600 mx-auto mt-10 rounded-full"></div>
                    </motion.div>
                </header>

                {/* --- GRID SECTION --- */}
                <div className="max-w-7xl mx-auto px-6 pb-32">
                    <motion.div 
                        variants={containerVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10"
                    >
                        {partenaires.map((partenaire, index) => (
                            <motion.div
                                key={index}
                                variants={itemVariants}
                                className={`group flex flex-col rounded-[2.8rem] border transition-all duration-500 hover:-translate-y-2 ${
                                    isDark 
                                    ? 'bg-gray-900/50 border-gray-800 hover:border-gray-700' 
                                    : 'bg-white border-gray-100 shadow-xl shadow-blue-900/5 hover:shadow-2xl hover:shadow-blue-900/10'
                                }`}
                            >
                                {/* Logo Container (Bento Style) */}
                                <div className="p-4">
                                    <div className={`h-40 w-full flex justify-center items-center rounded-[2rem] p-8 transition-colors ${isDark ? 'bg-white/5' : 'bg-gray-50'}`}>
                                        <img 
                                            src={partenaire.logo} 
                                            alt={partenaire.nom} 
                                            className="h-full w-auto object-contain transition-transform duration-500 group-hover:scale-110" 
                                        />
                                    </div>
                                </div>
                                
                                <div className="px-8 pb-8 flex flex-col flex-grow">
                                    <h2 className={`text-xl font-black mb-4 leading-tight ${isDark ? 'text-white' : 'text-[#1B365D]'}`}>
                                        {partenaire.nom}
                                    </h2>
                                    
                                    <p className={`text-sm font-light leading-relaxed mb-8 flex-grow opacity-70 ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                                        {partenaire.description}
                                    </p>
                                    
                                    <motion.a
                                        href={partenaire.site}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        whileHover={{ scale: 1.02 }}
                                        whileTap={{ scale: 0.98 }}
                                        className="mt-auto flex items-center justify-center gap-3 w-full bg-blue-600 text-white font-black py-4 px-6 rounded-2xl text-[10px] uppercase tracking-widest shadow-xl shadow-blue-600/20 hover:bg-blue-700 transition-all"
                                    >
                                        Visiter le site <FaExternalLinkAlt size={10} />
                                    </motion.a>
                                </div>
                            </motion.div>
                        ))}
                    </motion.div>
                </div>
            </div>
        </Box>
    );
};

export default NosPartenaires;